import { yup } from '@framework/validation/initYup.ts';
import { ConditionGroupExpressionSchema } from '../../../schema/expressions/repository/condition-group/ConditionGroupExpressionSchema.ts';
import { type IAdvancedRichTextItem } from '../IAdvancedRichText.ts';

const RichTextAdvancedItemSchema: yup.ObjectSchema<IAdvancedRichTextItem> = yup
  .object({
    type: yup.string().oneOf(['text', 'info']).required(),
    text: yup.string().notRequired(),
    rule: ConditionGroupExpressionSchema.notRequired().default(null),
  })
  .noUnknown()
  .required();

/**
 * Schema di validazione per il campo `label` di un widget in sezione modello.
 *
 * La transform normalizza i valori durante cast():
 * - stringa HTML legacy → array con un item di tipo 'text'
 * - undefined/null/[] → array con un item vuoto di tipo 'text'
 * Questo garantisce che useFieldArray riceva sempre un array valido
 * come defaultValues, evitando race condition con reset() di RHF.
 */
function createEmptyRteItem(): IAdvancedRichTextItem {
  return { text: '', type: 'text' };
}

export const RichTextAdvancedSchema = yup
  .array(RichTextAdvancedItemSchema)
  .meta({ rte: true })
  .default(() => [createEmptyRteItem()])
  .transform((value: unknown) => {
    // Caso legacy: se il valore è una stringa, la trasformiamo in un array con un item di testo
    if (typeof value === 'string')
      return [{ ...createEmptyRteItem(), text: value }];

    // Se il valore è un array vuoto, lo trasformiamo
    // in un array con un item vuoto
    if (Array.isArray(value) && value.length === 0)
      return [createEmptyRteItem()];

    return value;
  })
  .required();
